export function getRankingStyleForLayerName(layerName: string, cfg?: any): string | undefined {
    if (cfg && typeof cfg.rankingStyle === 'string' && cfg.rankingStyle.length > 0) return cfg.rankingStyle;
    const rankingStylesMap: Record<string, string> = {
        MARepairSegment: 'MARepairSegments_ranking',
    };
    return rankingStylesMap[layerName];
}


